import { Pipe, PipeTransform } from '@angular/core';
import { formatTimeZoneLabel } from '@app/pages/admin/orchestration-time-zones.util';

@Pipe({
  name: 'timeZoneLabel',
  standalone: true,
})
export class TimeZoneLabelPipe implements PipeTransform {
  transform(timeZoneId: string | null | undefined): string {
    const id = timeZoneId?.trim();
    return id ? formatTimeZoneLabel(id) : '—';
  }
}
